import { ITOServiceException as __BaseException } from "./ITOServiceException";
export class BadRequestException extends __BaseException {
    constructor(opts) {
        super({
            name: "BadRequestException",
            $fault: "client",
            ...opts
        });
        this.name = "BadRequestException";
        this.$fault = "client";
        Object.setPrototypeOf(this, BadRequestException.prototype);
    }
}
export class ForbiddenException extends __BaseException {
    constructor(opts) {
        super({
            name: "ForbiddenException",
            $fault: "client",
            ...opts
        });
        this.name = "ForbiddenException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ForbiddenException.prototype);
    }
}
export class InternalServerException extends __BaseException {
    constructor(opts) {
        super({
            name: "InternalServerException",
            $fault: "server",
            ...opts
        });
        this.name = "InternalServerException";
        this.$fault = "server";
        Object.setPrototypeOf(this, InternalServerException.prototype);
    }
}
export class NotFoundException extends __BaseException {
    constructor(opts) {
        super({
            name: "NotFoundException",
            $fault: "client",
            ...opts
        });
        this.name = "NotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, NotFoundException.prototype);
    }
}
export class ThrottlingError extends __BaseException {
    constructor(opts) {
        super({
            name: "ThrottlingError",
            $fault: "client",
            ...opts
        });
        this.name = "ThrottlingError";
        this.$fault = "client";
        this.$retryable = {};
        Object.setPrototypeOf(this, ThrottlingError.prototype);
    }
}
export class UnauthorizedException extends __BaseException {
    constructor(opts) {
        super({
            name: "UnauthorizedException",
            $fault: "client",
            ...opts
        });
        this.name = "UnauthorizedException";
        this.$fault = "client";
        Object.setPrototypeOf(this, UnauthorizedException.prototype);
    }
}
export class BRASSDependencyException extends __BaseException {
    constructor(opts) {
        super({
            name: "BRASSDependencyException",
            $fault: "server",
            ...opts
        });
        this.name = "BRASSDependencyException";
        this.$fault = "server";
        Object.setPrototypeOf(this, BRASSDependencyException.prototype);
        this.originalStatusCode = opts.originalStatusCode;
    }
}
export const FileStatus = {
    COMPLETED: "COMPLETED",
    COMPLETED_WITH_ERRORS: "COMPLETED_WITH_ERRORS",
    NOT_PROCESSED: "NOT_PROCESSED",
    PROCESSING: "PROCESSING",
    UPLOADED: "UPLOADED",
};
export class CatalogicalDependencyException extends __BaseException {
    constructor(opts) {
        super({
            name: "CatalogicalDependencyException",
            $fault: "server",
            ...opts
        });
        this.name = "CatalogicalDependencyException";
        this.$fault = "server";
        Object.setPrototypeOf(this, CatalogicalDependencyException.prototype);
        this.originalStatusCode = opts.originalStatusCode;
    }
}
export class OUIDependencyException extends __BaseException {
    constructor(opts) {
        super({
            name: "OUIDependencyException",
            $fault: "server",
            ...opts
        });
        this.name = "OUIDependencyException";
        this.$fault = "server";
        Object.setPrototypeOf(this, OUIDependencyException.prototype);
        this.originalStatusCode = opts.originalStatusCode;
    }
}
export const TicketStatus = {
    ASSIGNED: "ASSIGNED",
    OPEN: "OPEN",
    RESOLVED: "RESOLVED",
};
export class ExpectationFailedException extends __BaseException {
    constructor(opts) {
        super({
            name: "ExpectationFailedException",
            $fault: "client",
            ...opts
        });
        this.name = "ExpectationFailedException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ExpectationFailedException.prototype);
    }
}
